export class InfoCertificatoVO {
  signer: boolean;

  givenName: string;

  identifier: string;

  surname: string;

  notAfter: number;

  notBefore: number;

  caOrganization: string;

  subjectOrganization: string;
}
